import { render, staticRenderFns } from "./ProjectClient.vue?vue&type=template&id=1d0d0c40&scoped=true"
import script from "./ProjectClient.vue?vue&type=script&lang=js"
export * from "./ProjectClient.vue?vue&type=script&lang=js"
import style0 from "./ProjectClient.vue?vue&type=style&index=0&id=1d0d0c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d0c40",
  null
  
)

export default component.exports